"use client"

import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { selectLanguage } from "@/app/redux/store"

import ProjectCard from "../project-card/project-card"
import Label from "../label/Label"
import { getLabels, getPortfolioProjects } from "@/app/adapters/api"
import { GridSkeleton } from "../../skeleton/gridSkeleton"
import Link from "next/link"
import { Button } from "@/components/ui/button"

const labelsNames = [
  "goToPortfolioButton",
]

interface PrePortfolioProps {
  lang?: string;
}

export default function PrePortfolio(props: PrePortfolioProps) {

  const [loading, setLoading] = useState(true)
  const [labels, setLabels] = useState<any>({})
  //const lang = useSelector(selectLanguage)
  const [lang, setLang] = useState(props.lang || 'es')

  const [currentProjects, setCurrentProjects] = useState<any>([])

  useEffect(() => {
    getLabels(labelsNames)
      .then((response) => {
        setLabels(response.data.labels)
      })
      .finally(() => {
        setLoading(false)
      });
    getPortfolioProjects(7, 3)
      .then((response) => {
        setCurrentProjects(response.data.projects)
      })
      .finally(() => {
        setLoading(false)
      });
  }, [])

  

  return (
    <section className="mt-16 mb-20">
      {
        loading ?
        <GridSkeleton />
        :
        <>
          <div className="flex justify-center flex-wrap gap-8 mt-8 p-4">
            {currentProjects.map((project: any) => {
              return <ProjectCard key={project.id} projectId={project.id} lang={lang}/>
            })}
          </div>
          <div className="flex justify-center mt-4 mb-8">
            <Link href={lang === 'en' ? "/investment-examples/" : '/ejemplos-de-inversion'}>
              <Button className="mt-12" variant={'defaultRounded'}>
                <Label label={labels.goToPortfolioButton} lang={lang}/>
              </Button>
            </Link>
          </div>
        </>
      }
    </section>
  )
}
